import { render, staticRenderFns } from "./DeleteSessionModal.vue?vue&type=template&id=3805ef79&scoped=true&"
import script from "./DeleteSessionModal.vue?vue&type=script&lang=js&"
export * from "./DeleteSessionModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteSessionModal.vue?vue&type=style&index=0&id=3805ef79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3805ef79",
  null
  
)

export default component.exports